export default (prefix, customerId, userName) => `${prefix}-${customerId}-${userName}`;
